export default "__VITE_ASSET__fThMvUAJ__"